export const baseURL = process.env.REACT_APP_NEXTGEN_BASE_API_URL;
export const localURL = process.env.REACT_APP_NEXTGEN_LOCAL_API_URL;
export const reportServerUrl = process.env.REACT_APP_NEXTGEN_REPORTSERVER_URL;
export const chatBotURL = "https://genai.aes.corp/";
 
//export const baseURL = localURL;



//commom Urls
export const updateCustomSettings=`${baseURL}Common/InsertUpdateUserCustomSettings`;
export const getCustomSettings=`${baseURL}Common/GetUserCustomSettings/`

//Get URl for Fund List
export const assetListUrl = `${baseURL}assets/getassets`;
export const deleteAssetbyIdAPI=`${baseURL}Assets/DeleteAsset/`;
//Get URL for -- append Fund ID to the const
export const assetDetailsUrl = `${baseURL}assets/getassetdetails/`;
export const getMSDetailSection = `${baseURL}InvFeeds/GetStockOverview/`;
export const getAssetCurrencyTypeAPI=`${baseURL}Common/GetAssetCurrency/`

//Get URL for Portfolios
export const getPortfolios = `${baseURL}common/getportfolios`;

//Get URL for Portfolios Filter --append text to get all the portfolios that contains that name 
export const getPortfoliosFiltered = `${baseURL}general/getportfolios/`;

//Get gettaxDetails --questions api --append year --
export const gettaxDetails = `${baseURL}assettax/getassettaxsettings/`;

//Get gettaxDetails answer for selected portfolio 
//eg :assettax/getassettaxdetailsbyfundandyear/FundID,Year,PortfolioID
export const getTaxDetailsForPortfolio = `${baseURL}assettax/getassettaxdetailsbyassetandyear/`;

// PortFolio
export const deletePortfolioApi=`${baseURL}Portfolios/DeletePortfolio/`
export const getPortfolioListAPI=  `${baseURL}Portfolios/GetPortfolioList`;
export const getPortfolioDetailAPI=`${baseURL}Portfolios/GetPortfolioDetails/`;
export const getPortfolioTypeAPI=`${baseURL}Common/GetEnumeration/PortfolioType`;
export const getPortfolioCurrencyAPI=`${baseURL}common/GetCurrencyInfo`;
export const getPortfolioCashAPI=`${baseURL}Portfolios/GetPortfolioDefaultAccounts/2`;
export const getPortfolioExpenseAPI=`${baseURL}Portfolios/GetPortfolioDefaultAccounts/7`;
export const getPortfolioCreditFacilityAPI=`${baseURL}Portfolios/GetPortfolioDefaultAccounts/4`;
export const getPortfolioMangerAPI=`${baseURL}Common/GetAllUsers?jobTitleid=1`;
export const getPortfolioTaxStatusAPI=`${baseURL}Common/GetEnumeration/TaxStatus`;
export const getPortfolioDiscretionaryStatusAPI=`${baseURL}Common/GetEnumeration/DiscretionStatus`;
export const insertOrUpdatePortfolioAPI=`${baseURL}Portfolios/InsertOrUpdatePortfolioDetails`;
export const getPortfolioAvailableAsset=`${baseURL}Portfolios/GetPortfolioAvailableAssets/`;
export const getPortfolioExistingAsset=`${baseURL}Portfolios/GetPortfolioExistingAssets/`;
export const getPortfolioAccountsApi=`${baseURL}Portfolios/GetPortfolioTaxEntities/`;
export const insertPorfolioAccountingAssetAPI = `${baseURL}Portfolios/InsertPortfolioAccountingAsset`;
export const getPortfolioLedgerAccountsAPI = `${baseURL}Portfolios/GetPortfolioLedgerAccounts`
export const getPortfolioNonCashAccounts = `${baseURL}Portfolios/GetPortfolioNonCashAccounts`;
export const getexistingshareclass = `${baseURL}Portfolios/GetPortfolioExistingShrClassesByAsset/`;
export const getPortfolioMarketableList = `${baseURL}Assets/GetInvestedPortfolios/assetId`;
export const getPortfolioPerfAndStats = `${baseURL}PortfolioStats/GeneratePortfolioStats`;



export const getAssetAllocRpt = `${baseURL}InvestorTrackingReporting/GetAssetAllocRptConsolidated`;
export const excelfiledownload = `${baseURL}InvestorTrackingReporting/ExcelExport`;
export const getQuarterNames = `${baseURL}InvestorTrackingReporting/GetQuarterNames`;
export const insertUpdateCashEntry = `${baseURL}InvestorTrackingReporting/InsertUpdateCashEntry`;
export const getPDFDownload = `${baseURL}ReportingEx/GetAssetAllocationReport`;
//portfolio transaction portfolio submenu 
export const getPortfolioTransaction=`${baseURL}Transactions/GetPortfolioTransactions/`;

//Get getTaxDetails summary Alone for selected portfolio
//eg :assettax/getassettaxsummary/FundID,year,PortfolioID
export const getTaxDetailsSummaryForPortfolio = `${baseURL}assettax/getassettaxsummary/`;
export const insertOrUpdateAssetTax = `${baseURL}assettax/InsertOrUpdateAssetTax/`;

//Get assetList 
export const getAssetListDdl = `${baseURL}common/getassetsddl`;
export const getAssetListByTermApi = `${baseURL}common/getassetsddl/`;

//GetHoldingDatabyFunda
export const getMinMax = `${baseURL}holdings/GetHoldingsMinMaxDates`;
export const getHoldingsSummary = `${baseURL}holdings/GetHoldingsSummaryData/`;
export const getHoldings = `${baseURL}holdings/GetHoldings13fSummaryByFund/`;
export const getHoldingData = `${baseURL}holdings/GetHoldingsDataByFund/`

//getFinancialStatement
export const getFinancialStatementUrl = `${baseURL}AssetFinancialStatement/GetFinancialStatements/`
export const InsertorUpdateStatement = `${baseURL}AssetFinancialStatement/InsertFinancialStatement/`;
export const getFinancialStatementDocument = `${baseURL}Activity/GetDocumentsBySubType/`
export const Deletenonverifiedstatement = `${baseURL}AssetFinancialStatement/DeleteNonVerifiedStatement/`;
export const InsertAnalystReviewed = `${baseURL}AssetFinancialStatement/InsertAnalystReviewed`;

//getSecurityType
export const getSecurityTypeDdl = `${baseURL}common/GetAssetTypes`;

//getInvestment
export const getInvestmentStatusDdl = `${baseURL}Common/GetEnumeration/InvestmentStatus`;
export const getGetEnumeration = `${baseURL}Common/GetEnumeration/`;
export const getActivityDetails = `${baseURL}Activity/GetActivityDetails/`;
export const insertOrUpdateActivityDetails = `${baseURL}Activity/InsertOrUpdateActivityDetails`;
export const insertOrUpdateActivityDocument = `${baseURL}Activity/InsertOrUpdateActivityDocument`;
export const DeleteDocument = `${baseURL}Activity/DeleteDocument/`;
export const getAccountorContact = `${baseURL}Activity/GetEntities`;
export const UpdateActivityDocumentname = `${baseURL}Activity/UpdateActivityDocumentName`;

//export const insertUpdateLogo = `${baseURL}Authorization/InsertUpdateLogo`;
//getAssetclass
export const getAssetclass = `${baseURL}Common/GetClassificationItems/1`;

//Fund Status
export const getFundStatusDdl = `${baseURL}Common/GetAssetStatus`;

//Primary Analyst
export const getPrimaryAnalystDdl = `${baseURL}Common/GetAnalysts`;

//secondry Analyst
export const getSecondaryAnalystDdl = `${baseURL}Common/GetAnalysts`;

//Strategy
export const getStrategyDdl = `${baseURL}Common/GetClassificationItems/14`;

//	Sub Strategy
export const getSubStrategyDdl = `${baseURL}Common/GetClassificationItems/29`;

//Region
export const getRegionDdl = `${baseURL}Common/GetClassificationItems/75`;

//SubRegion
export const getSubRegionDdl = `${baseURL}Common/GetClassificationItems/81`;

//Sector
export const getSectorDdl = `${baseURL}Common/GetClassificationItems/63`;

//SubSector
export const getSubSectorDdl = `${baseURL}Common/GetClassificationItems/74`;

//Return And Statistics
export const getReturnsGrid = `${baseURL}AnalyticsStats/GetReturnsGrid/`;
export const getMinMaxReturnDates = `${baseURL}Common/GetMinMaxReturnDates/`;
export const getreturnschart = `${baseURL}AnalyticsStats/GetReturnsChart/`;
export const getPerfCalendarYrs = `${baseURL}AnalyticsStats/GetPerfCalendarYrs/`;
export const getTrailingPerf = `${baseURL}AnalyticsStats/GetTrailingPerf/`;
export const getCalYrsVsBM = `${baseURL}AnalyticsStats/GetCalYrsVsBM/`;
export const getStatSummary = `${baseURL}AnalyticsStats/GetStatSummary/`;
export const getDDHistoryVsBM = `${baseURL}AnalyticsStats/GetDDHistoryVsBM/`;
export const getRollingExcessReturns = `${baseURL}AnalyticsStats/GetRollingExcessReturns/`;
export const getCumulativeReturnsChart = `${baseURL}AnalyticsStats/GetCumulativeReturnsChart/`;
export const getDistReturnsChart = `${baseURL}AnalyticsStats/GetDistReturnsChart/`;

//Left Menu
export const getLeftMenuItems = `${baseURL}Common/GetMenu`;

//Asset AUM
export const getAssetAUMList = `${baseURL}AssetAUM/GetAssetAUM/`;

//Asset Returns
export const getAssetReturnsList = `${baseURL}AnalyticsStats/GetAssetReturnsSummaryex/`;

//Asset ShareClassTerms
export const getAssetShareclassTermsList = `${baseURL}AssetShareClass/GetShareClassTerms/`;

//Asset Private Exposure
export const getAssetPrivateExposureSummary = `${baseURL}Exposure/GetPrivateExposureSummary/`;
export const updatePrivateTemplateByAsset = `${baseURL}Exposure/UpdatePrivateTemplateByAsset`;


export const GetAnalystTypes = `${baseURL}Exposure/GetAnalystTypes`;
export const GetRawByAsset = `${baseURL}Exposure/GetRawByAsset`;
export const InsertUpdateAssetMapping = `${baseURL}Exposure/InsertUpdateAssetMapping`;
export const GetAssetMappings = `${baseURL}Exposure/GetAssetMappings`;
export const DeleteAssetMapping = `${baseURL}Exposure/DeleteAssetMapping`;

//Asset Service Provider
export const getServiceProviderDetails = `${baseURL}Assets/GetServiceProviders`;
export const insertUpdateServiceProvider = `${baseURL}Assets/InsertUpdateServiceProvider`;
export const deleteServiceProvider = `${baseURL}Assets/DeleteServiceProvider`;
export const getCompanyTypes = `${baseURL}Assets/GetCompanyTypes`;
export const getCompanyByType = `${baseURL}Assets/GetCompanyByType`;
export const getCompanyContactsAPI = `${baseURL}Common/GetCompanyContacts`;

//AssetSetting Page
export const getBenchmarkEntity = `${baseURL}Common/GetBenchmarkEntities/`
export const getAssetSettingsList = `${baseURL}Assets/GetAssetBMSettings/`;

//Asset Shareclass
export const getAssetShareClassddl = `${baseURL}AssetShareClass/GetShareClassListByAssetId/`;
export const getAssetShareClassdetails = `${baseURL}AssetShareClass/GetShareClassAttributes/`;
export const getAssetShareClassFeedetails = `${baseURL}AssetShareClass/GetShareClassFees/`;

//Asset Attributes
export const getAttributesdetails = `${baseURL}Assets/GetAssetAttributes/`;
export const getChartofaccounts = `${baseURL}Common/GetChartOfAccounts/`;
export const getAssetRatings = `${baseURL}Assets/GetAssetRatings/`;
export const deleteAssetRatings = `${baseURL}Assets/DeleteAssetRatings/`;
export const insertUpdateAssetRatings = `${baseURL}Assets/InsertUpdateAssetRatings`;
export const getLegalStructure = `${baseURL}Common/GetEnumeration/LegalStructure`;
export const getAssetSecurityType = `${baseURL}Common/GetEnumeration/AssetSecurityType`;
export const getInvestmentType = `${baseURL}Common/GetEnumeration/InvestmentType`;
export const getInvestorLetterFrequency = `${baseURL}Common/GetEnumeration/InvestorLetterFrequency`;
export const getPerformanceEstimateFrequency = `${baseURL}Common/GetEnumeration/PerformanceEstimateFrequency`;
export const getReportingFrequency = `${baseURL}Common/GetEnumeration/ReportingFrequency`;
export const getExposureReportingFrequency = `${baseURL}Common/GetEnumeration/ExposureReportingFrequency`;
export const getFilingStatus = `${baseURL}Common/GetEnumeration/FilingStatus`;
export const getInvestsInOtherFunds = `${baseURL}Common/GetEnumeration/InvestsInOtherFunds`;
export const getFrequencies =`${baseURL}Common/GetFrequencies/`;
export const getCommon=`${baseURL}Common/`;
export const getLiquidityRequiredNotice =`${baseURL}Common/GetEnumeration/LiquidityRequiredNoticeFrequency`;
export const getLiquidityLockType = `${baseURL}Common/GetEnumeration/LiquidityLockType`;
export const getLiquidityLockupFrequency = `${baseURL}Common/GetEnumeration/LiquidityLockupFrequency`;
export const InsertorUpdateAttributes = `${baseURL}Assets/InsertUpdateAssetAttributes`;
export const InsertorUpdatePEAttributes = `${baseURL}Assets/InsertUpdateAssetAttributesPE`;
export const InsertorUpdateHFAttributes = `${baseURL}Assets/InsertUpdateAssetAttributesHF`;
export const InsertorUpdateMSAttributes = `${baseURL}Assets/InsertUpdateAssetAttributesMS`;
export const insertAssetManager = `${baseURL}Assets/InsertAssetManager/`;
export const getInvestmentTasks = `${baseURL}Dashboard/GetInvestmentTasks`;
export const getAssetExposures = `${baseURL}Dashboard/GetAssetExposures`;

// asset details widget
export const getAssetPortfolioWidget = `${baseURL}Assets/GetAssetPortfolio`;
export const getAssetTransactionWidget = `${baseURL}Assets/GetAssetTransaction`;

//commom api url link 
export const getDDListValues = `${baseURL}AssetShareClass/GetDropdownListsValues`;
export const getCurrencyInfo = `${baseURL}Common/GetCurrencyInfo`;
export const getCountries = `${baseURL}Common/getCountries`;
export const getContactRM=`${baseURL}Common/GetContacts?`

//Asset Documents
export const getAssetDocWidget = `${baseURL}Activity/GetAssetDocWidget/`;
export const getDocbyActivityId = `${baseURL}Activity/GetMultipleDocs/`;
export const getDocdetailsbyDocumentId =`${baseURL}Activity/GetDocument/`

//Asset notes tab
export const getAssetNotesTabDetail = `${baseURL}Activity/GetNotes/`;
export const getAssetNoteDetail = `${baseURL}Activity/GetNote/`

//Home page
export const getFirmSummary = `${baseURL}Dashboard/GetFirmSummary`;
export const GetCSDocumentsAPI = `${baseURL}Dashboard/GetCSDocuments`;
export const getFamilySummary = `${baseURL}Dashboard/GetFamilySummary`;
export const getMgmtSummary = `${baseURL}Dashboard/GetMgmtSummary`;
export const getClassiSummary = `${baseURL}Dashboard/GetClassiSummary`;
export const getPortfolioSummary=`${baseURL}Dashboard/getDashboardPortfolioSummary`;
export const getFamilyNetWorth=`${baseURL}Dashboard/GetFamilyNetWorth`;
export const getServiceHealth=`${baseURL}Dashboard/GetEnterpriseServiceHealth`;
export const getServiceHealthTypes=`${baseURL}Dashboard/GetEnterpriseServiceTypes`;
export const getServiceStatusKeys = `${baseURL}Dashboard/GetServiceStatusKey`;
export const getInvestedAssetPerf = `${baseURL}Dashboard/GetInvestedAssetPerf`;
export const getInvestedIndexPerf = `${baseURL}Dashboard/GetInvestedIndexPerf`;
export const getMyActivities = `${baseURL}Dashboard/GetMyActivities`;
export const getInvestmentMeetings = `${baseURL}Dashboard/GetInvestmentMeetings`;
export const getInvestmentDDQ = `${baseURL}Dashboard/GetInvestmentDDQ`;
export const getInvestedAssetAUM = `${baseURL}Dashboard/GetInvestedAssetAUM`;

// Investors
export const getActivities = `${baseURL}Activity/GetActivities?`;
export const getcategory = `${baseURL}Activity/GetActivitySubType/`;
export const getactivityType = `${baseURL}Activity/GetActivityType`;
export const getActivityentityType = `${baseURL}Activity/GetActivityEntityType/`;
export const getActivityEntity = `${baseURL}Activity/GetEntities?`;
export const deleteActivity=`${baseURL}Activity/DeleteActivity/`
export const deleteTaskAPI =`${baseURL}Activity/DeleteTask/`
export const getDocumentStatus=`${baseURL}Activity/GetDocumentStatus/`;

//profile 
export const getUserDetails = `${baseURL}UserProfile/GetUserDetails/`;

// Asset InsertorUpdate
export const InsertorUpdateAsset = `${baseURL}Assets/InsertUpdateAssetDetails`;

// BMSettings
export const InsertAssetBMSetting = `${baseURL}Assets/InsertAllBMSettings`;
export const DeleteAssetBMSetting = ` ${baseURL}Assets/DeleteAssetBMSettings/`;

//ShareClass Insert
export const InsertorUpdateShareClass = `${baseURL}AssetShareClass/InsertOrUpdateShareClass`;

//Get AllUsers
export const getAllUserList = `${baseURL}Common/GetAllUsers`;

//Get AllUsers
export const getManagerContactsList = `${baseURL}Common/GetManagerContacts`;

//Documnet Download
export const DownloadDocument = `${baseURL}Activity/GetDocumentDownload/`;
export const DownloadMultiDocument =`${baseURL}Activity/GetMultipleDocuDownload/`;

//anlaytics and reporting 
export const getUniverseList = `${baseURL}Universes/GetUniverses`;
export const getUniverseMembers = `${baseURL}Universes/GetUniverseMembers/`;
export const UniverseInsertorUpdate = `${baseURL}Universes/InsertUpdateUniverse`;
export const deleteUniverse=`${baseURL}Universes/DeleteUniverse/`;
export const getUniverseReturnsApi=`${baseURL}Universes/GetUniverseAnlayticsReturns/`;
export const getSelectedUniverseDetails=`${baseURL}Universes/GetUniverses?UniverseId=`

//Exposure
export const getMatchingTickers = `${baseURL}Exposure/GetMatchingTickers/`
export const getTickerLookup = `${baseURL}Exposure/GetTickerLookup/`
export const getPublicExposureAssets = `${baseURL}Exposure/GetPublicExposureAssets?`
export const getPublicExposureMinMaxAssetDates = `${baseURL}Exposure/GetPublicExposureMinMaxAssetDates/`
export const getPublicExposureOverlapAnalysisReportData = `${baseURL}Exposure/GetPublicExposureOverlapAnalysisReportData/`
export const getPrivateExposureAssetList = `${baseURL}Exposure/GetPrivateExposureAssetList/`
export const getPrivateExposureCategoryTypes = `${baseURL}Exposure/GetPrivateExposureCategoryTypes?`
export const getPrivateExposureAssetData = `${baseURL}Exposure/GetPrivateExposureAssetData/`;
export const getPrivateTemplateByAsset=`${baseURL}Exposure/GetPrivateTemplatesByAsset/`;
export const getPrivateTemplateCategories=`${baseURL}Exposure/GetPrivateTemplateCategories/`;

export const getPrivateRawCategory = `${baseURL}Exposure/GetPrivateRawCategory`;
export const getPrivateRawData = `${baseURL}Exposure/GetPrivateRawData`;
export const insertUpdatePrivateRawData=`${baseURL}Exposure/InsertUpdatePrivateRawData`;
export const exposureTemplateAPI =`${baseURL}Exposure/DownloadExposureDataTemplate`;

// exposure analyst 
export const getAnalystGridSectHeader=`${baseURL}Exposure/GetExposureSections/`;
export const getAnalystGridData=`${baseURL}Exposure/GetAssetExposureData/`;
export const InsertAnalystExposureData=`${baseURL}Exposure/InsertAssetExposureData`;

//global search 
export const getAllEntitiesGlobal = `${baseURL}Common/GetAllEntities/`;
export const getSecuritiesAPI = `${baseURL}Common/GetSecurities`;

//user details
export const getCurrentUserDetails = `${baseURL}common/GetLoggedUser?emailAddress=`;

//Email Rule
export const getEmailrule = `${baseURL}Exchange/GetEmailRules/`
export const deleteEmailrule = `${baseURL}Exchange/SetEmailRuleInactive/`;
export const EmailruleInsertorUpdate = `${baseURL}Exchange/InsertOrUpdateEmailRule`;
export const InsertOrUpdateEmailAttachmentSecurity = `${baseURL}Exchange/InsertOrUpdateEmailAttachmentSecurity`;
export const getEmailAttachmentSecurity = `${baseURL}Exchange/GetEmailAttachmentSecurity`
export const CheckEmailRuleNameExists = `${baseURL}Exchange/CheckEmailRuleNameExists/`;
export const getPublicExposureTSCharts = `${baseURL}Exposure/GetPublicExposureTSCharts/`;
export const getOverlapAssetsforUniverse = `${baseURL}Exposure/GetOverlapAssetsforUniverse/`;

//AUM
export const getAssetAUMOpt = `${baseURL}AssetAUM/GetAssetAUMConsol/`;
export const InsertAUM=`${baseURL}AssetAUM/InsertAssetAUM`;
export const UpdateAUM = `${baseURL}AssetAUM/UpdateAssetAUM`;
export const InsertorUpdateAUM=`${baseURL}AssetAUM/InsertOrUpdateAUM`;
export const DeleteAUM = `${baseURL}AssetAUM/DeleteAssetAUM?`;
export const getPrivateExposureCategoryTypeDates = `${baseURL}Exposure/GetPrivateExposureCategoryTypeDates/`;
export const InsertFinancialInvestmentTotal=`${baseURL}AssetFinancialStatement/InsertFinancialStatementInvestments`;
export const InsertFinacialsummary = `${baseURL}AssetFinancialStatement/InsertFinancialStatementSummaryAndValues`;
export const CheckExistsFinancialStatementInvestment=`${baseURL}AssetFinancialStatement/CheckExistsFinancialStatementInvestment/`;
export const DeleteNonVerifiedSecurities=`${baseURL}AssetFinancialStatement/DeleteNonVerifiedSecurities/`
export const InsertSecurity=`${baseURL}AssetFinancialStatement/InsertSecurity/`

//Admin Permissions
export const getTenants = `${baseURL}Authorization/GetTenants`;
export const getRoles = `${baseURL}Authorization/GetRoles`;
export const getServices = `${baseURL}Authorization/GetServices`;
export const getUsers = `${baseURL}Authorization/GetUsers`;
export const insertUpdateTenant = `${baseURL}Authorization/InsertUpdateTenant`;
export const insertUpdateRole = `${baseURL}Authorization/InsertUpdateRole`;
export const insertUpdateService = `${baseURL}Authorization/InsertUpdateService`;
export const insertUpdateUser = `${baseURL}Authorization/InsertUpdateUser`;
export const getUserSubMenu=`${baseURL}Authorization/GetUserMenuAccess/`
export const InsertUpdateMenu = `${baseURL}Authorization/InsertUpdateMenu`;
export const DeleteTenant = `${baseURL}Authorization/DeleteTenant/`;
export const deleteRole = `${baseURL}Authorization/DeleteRole/`;
export const deleteUserId = `${baseURL}Authorization/DeleteUserId/`;
export const deleteService = `${baseURL}Authorization/DeleteService/`;
export const deleteMenu = `${baseURL}Authorization/DeleteMenu/`;
export const getDefaultPage =`${baseURL}Authorization/GetDefaultPages`;
export const getUserPageAccess=`${baseURL}Authorization/GetUserPageAccess`;
export const getUsersByTenant=`${baseURL}Authorization/GetUsers?tenantId=`;
export const getAllUserPageRightsByTenant=`${baseURL}Authorization/GetAllUserPageAccess/`;
export const updatedPageAccess=`${baseURL}Authorization/InsertUpdatePageAccess`;
export const getThemes=`${baseURL}Authorization/GetThemes`;
export const getReports=`${baseURL}Authorization/GetReports`;
export const getThemeDetails=`${baseURL}Authorization/GetThemeDetails`;
export const getThemeList=`${baseURL}Authorization/GetThemeList`;
export const insertOrUpdateThemedetail = `${baseURL}Authorization/InsertOrUpdateThemedetail`;
export const getReportPartList=`${baseURL}Authorization/GetReportPartList`;
export const getReportpartListById=`${baseURL}Authorization/GetReportReportpartListById/`;
export const UpdateReportPartList = `${baseURL}Authorization/UpdateReportPartById`;
export const insertOrUpdateReport = `${baseURL}Authorization/InsertOrUpdateReport`;
export const insertUpdateLogo = `${baseURL}Authorization/InsertUpdateLogo`;
export const getClassificatioParents = `${baseURL}ApplicationSettings/GetClassificationParents`;
export const getAdminClassificationItems = `${baseURL}ApplicationSettings/GetClassificationItems`;
export const insertOrupdateClassification = `${baseURL}ApplicationSettings/InsertOrUpdateClassification`;
export const getPortfolioUserAccess = `${baseURL}Authorization/GetPortfolioUserAccess`;
export const getUsersByPortfolioAccess = `${baseURL}Authorization/GetUsersByPortfolioAccess`;
export const upsertUserPortfolioAccess = `${baseURL}Authorization/UpsertUserPortfolioAccess`;

export const getUsersByTaxEntityAccess = `${baseURL}Authorization/GetUsersByTaxEntityAccess`;
export const upsertUserTaxEntityAccess = `${baseURL}Authorization/UpsertUserTaxEntityAccess`;



export const getUsersByContactAccess = `${baseURL}Authorization/GetUsersByContactAccess`;
export const upsertUserContactAccess = `${baseURL}Authorization/UpsertUserContactAccess`;





//Post Returns
export const getAssetValuations = `${baseURL}AssetValuation/GetAssetValuations/`;
export const insertUpdateAssetValuation = `${baseURL}AssetValuation/InsertUpdateAssetValuation`;
export const DeleteAssetValuation = `${baseURL}AssetValuation/DeleteAssetValuation`;
export const getAssetLotsUrl=`${baseURL}PortfolioValuations/GetAssetLots/`;
export const getAssetLotsPlainAPI=`${baseURL}PortfolioValuations/GetAssetlotsPlain/`;
export const portfolioPostReturns = `${baseURL}PortfolioValuations/PostReturns`;
export const DeletePricing=`${baseURL}PortfolioValuations/DeletePricing`;
export const getMktSecValuationByAsset=`${baseURL}Portfolios/GetMktSecValuationByAsset/`;
export const getMktSecimport=`${baseURL}Portfolios/GetMktSecImportBalances`;
export const insertorUpdateMktSec = `${baseURL}Portfolios/InsertOrUpdateMktSec`;
export const DownloadMktSecFile = `${baseURL}Portfolios/DownloadFile`;
export const deleteMktSec=`${baseURL}Portfolios/DeleteMktSec/`;
//Import Returns
export const updateImportReturns = `${baseURL}AssetValuation/BulkReturnsImport`;
export const updateAssetAUMImportReturns = `${baseURL}AssetValuation/BulkAassetAUMReturnsImport`;

// Market data
export const getMarketDataIndices = `${baseURL}MarketData/GetMarketDataIndices/`;
export const getMarketDataDetail = `${baseURL}MarketData/GetMarketDataDetail/`;
export const getDSList=`${baseURL}Common/GetDataSources/`;
export const insertorUpdateMarketData=`${baseURL}MarketData/InsertUpdateMarketData`
export const deleteMarketData=`${baseURL}MarketData/DeleteMarketData/`;

//secure Login
export const secureLogin=`${baseURL}SecureAuthentication/Login`;

//Get user  Role
export const getRoleUser =`${baseURL}Authorization/GetRoleUsers?roleId=`;
export const assignUserToRole=`${baseURL}Authorization/InsertUpdateUserToRole`;
export const deleteUserRole=`${baseURL}Authorization/DeleteUserToRole/`;
export const getRoleAttributes = `${baseURL}Authorization/GetRoleAttributes/`;
export const getMenusToRole = `${baseURL}Authorization/GetMenusToRole?roleId=`;
export const deleteMenutoRole = `${baseURL}Authorization/DeleteMenuToRole/`;
export const insertUpdateMenuToRole = `${baseURL}Authorization/InsertUpdateMenuToRole/`;
export const getAvailableMenus = `${baseURL}Authorization/GetAvailableMenus/`;
export const getSubMenusToRole = `${baseURL}Authorization/GetSubMenusToRole?roleId=`;
export const deleteSubMenuToRole = `${baseURL}Authorization/DeleteSubMenuToRole/`;
export const getAvailableSubMenus = `${baseURL}Authorization/GetAvailableSubMenus/`;
export const insertUpdateSubMenuToRole = `${baseURL}Authorization/InsertUpdateSubMenuToRole/`;
export const deleteMenuAndsubmenu = `${baseURL}Authorization/DeleteMenuAndsubmenu/`;

//Get Enumeration
export const getEnumerations=`${baseURL}Common/GetEnumeration/`;

//AllowedMenus
export const getallowedmenus=`${baseURL}Authorization/GetAllowedMenus?userId=`

//Contacts
export const getContacts = `${baseURL}Contact/GetContacts`;
export const getContactDetails = `${baseURL}Contact/GetContactDetails/`;
export const getContactAccess =`${baseURL}Contact/GetContactAccess`;
export const getContactHeader = `${baseURL}Contact/GetContactHeader/`;
export const updateContactHeader = `${baseURL}Contact/UpdateContactHeader?`;
export const getContactInfo = `${baseURL}Contact/GetContactInfo/`;
export const getBusinessUnits = `${baseURL}Contact/GetCompanyBusinessUnit`;
export const insertOrUpdateContactGeneral = `${baseURL}Contact/InsertOrUpdateContactGeneral?`;
export const insertOrUpdateContactAddresses = `${baseURL}Contact/InsertOrUpdateContactAddresses?`;
export const insertOrUpdateContactOtherAttributes = `${baseURL}Contact/InsertOrUpdateContactOtherAttributes?`;
export const deleteContactImage = `${baseURL}Contact/DeleteContactImage/`;
export const getContactWebCategories = `${baseURL}Contact/GetContactWebCategories/`;
export const getContactWebStatusTypes = `${baseURL}Contact/GetContactWebStatusTypes/`;
export const getParentCompanies = `${baseURL}Contact/GetParentCompanies/`;
export const getTaxEntitiesByContact = `${baseURL}Contact/GetTaxEntitiesByContact/`;
export const deleteContactbyIDAPI = `${baseURL}contact/DeleteContact/`;
export const getClientProfileDocuments = `${baseURL}contact/GetClientProfileDocuments/`;
export const getClientProfileNotes = `${baseURL}contact/GetClientProfileNotes/`;
export const getClientProfileTracker = `${baseURL}contact/GetClientProfileTracker/`;
export const getClientProfileGetTasks = `${baseURL}contact/GetClientProfileGetTasks/`;
export const getRMContacts = `${baseURL}Contact/GetRMContacts`;


//Company
export const getCompanyInfo = `${baseURL}Company/GetCompanyInfo/`;
export const insertorupdatecompany = `${baseURL}Company/InsertOrUpdateCompany`;
export const insertorupdatecompanyaddress=`${baseURL}Company/InsertOrUpdateCompanyAddresses`;
export const deleteCompanyAPI = `${baseURL}Company/deleteCompany/`;

// Tasks
export const getTaskTypes=`${baseURL}Activity/GetTaskTypes`;
export const getTaskAssignees=`${baseURL}Activity/GetTaskAssignees`;
export const getTaskDetails=`${baseURL}Activity/GetTaskDetails/`;
export const getTaskDocuments = `${baseURL}Activity/GetTaskDocuments/`;
export const getTasks = `${baseURL}Activity/GetTasks`;
export const getTaskWithSubTask = `${baseURL}Activity/GetTaskWithSubTask`;
export const getTaskViewSettings = `${baseURL}Activity/GetTaskViewSettings/`;
export const getTaskViewColums= `${baseURL}Activity/GetActivityTaskViewColumnsSelect/`;
export const getActivityTaskViewSelect = `${baseURL}Activity/GetActivityTaskViewSelect`;
export const getAvailableTaskViewColumns = `${baseURL}Activity/GetAvailableTaskViewColumns/`;
export const insertTaskViewsColumn = `${baseURL}Activity/InsertTaskViewsColumn`;
export const updateTaskViewName = `${baseURL}Activity/UpdateTaskViewName`;
export const deleteActivityTaskView = `${baseURL}Activity/DeleteActivityTaskView/`;
export const insertorupdateTask = `${baseURL}Activity/InsertorupdateTask`;
export const updateTaskComplete = `${baseURL}Activity/UpdateTaskcompleted`;
export const deleteSubTaskAPI=`${baseURL}Activity/DeleteSubTask/`;


// Task board
export const updateSubTaskAPI=`${baseURL}Activity/InsertOrUpdateSubTask`;

//ContactLists
export const getStaticContacts=`${baseURL}ContactList/GetContactLists/0`;
export const getDyanmicContacts=`${baseURL}ContactList/GetContactLists/1`;
export const getAllContactListAPI=`${baseURL}ContactList/GetContactLists`;
export const getContactList=`${baseURL}ContactList/GetContacts/`;
export const insertOrUpdateStaticList=`${baseURL}ContactList/InsertOrUpdateStaticList`;
export const getDyanmicContactListDetails=`${baseURL}ContactList/GetDynamicListDetails/`;
export const GetDynamicListInvestors=`${baseURL}ContactList/GetDynamicListContacts`;
export const getDyanmicDateRange=`${baseURL}ContactList/GetDynamicListDates/`;
export const insertOrUpdateDynamicList = `${baseURL}ContactList/InsertOrUpdatetDynamicList`;
export const deleteContactListApi = `${baseURL}ContactList/DeleteContactList/`
export const getStaticListContacts = `${baseURL}ContactList/GetStaticListContacts/`;
export const getDynamicContactListSearchType = `${baseURL}Common/GetEnumeration/ContactListSearchType`;
export const getProbability = `${baseURL}Pipeline/GetProbability/`;
export const getPipelineStatus = `${baseURL}Pipeline/GetStatus/`;
export const getInvestorByPipeLine=`${baseURL}ContactList/GetContactListDynamicListPipelineContacts/`;
export const getContactListByTypeTextAPI=`${baseURL}ContactList/GetContactsbyType`;
export const getContactByContactListAPI=`${baseURL}ContactList/GetContactsByContactListID`

//financial Statement 
export const getFinancialInvestmentsDropdown = `${baseURL}AssetFinancialStatement/GetFinancialInvestmentsDropdown`

//ProForma
export const getProformas = `${baseURL}ProForma/GetProformas`;
export const getProformaOptions = `${baseURL}ProForma/GetProformaOptions`;
export const getProforma = `${baseURL}ProForma/GetProforma`;
export const getEntities = `${baseURL}ProForma/GetEntities`;
export const deleteProformaByID=`${baseURL}Proforma/DeleteProforma`;
export const allocationDetailsById=`${baseURL}Proforma/CalculateProforma`
export const updateProforma = `${baseURL}Proforma/UpdateProforma`
export const saveProforma = `${baseURL}Proforma/SaveProforma`
export const getTaxEntities = `${baseURL}Common/GetTaxEntities/`
export const getCrmDocumentTyes = `${baseURL}Document/GetCrmDocumentTypes`
export const getAllocationDetByDateId=`${baseURL}ProForma/CalculateProformaByDate`;
export const getPDFReport = `${baseURL}Reporting/GetPdfReport`;
export const getProformaTopIndices = `${baseURL}Proforma/GetProformaTopIndices/`;
export const getRiskFreeRatio = `${baseURL}Proforma/GetRiskFreeRatio`;
export const insertSetIndex = `${baseURL}Proforma/InsertSetIndex`;
export const getSetIndex = `${baseURL}Proforma/GetSetIndex`;
export const deleteSetIndex = `${baseURL}Proforma/DeleteSetIndex`;
export const getSetCorrelationBm = `${baseURL}Proforma/GetSetCorrelationBm`;
export const updateSetRiskFreeRatio = `${baseURL}Proforma/UpdateSetRiskFreeRatio`;
export const updateSetCorrelationBm = `${baseURL}Proforma/UpdateSetCorrelationBm`;


// https://webapp/Proforma/DeleteProforma?proformaId=012121212121212&userId=12312312312


// pricing
export const getpricinglist = `${baseURL}PortfolioValuations/GetPricingLotList/`
export const postpricingdata = `${baseURL}PortfolioValuations/PostPortfolioValuations`

// Transactions
export const gettransactionslist = `${baseURL}Transactions/GetTransactionsByAsset/`;
export const getTransactionStatusAPI=`${baseURL}Transactions/GetTransactionStatus`;
export const getTransactionsMenulist = `${baseURL}Transactions/GetTransactionTypeMenuByAsset/`;
export const getTransactionAssetsByType = `${baseURL}Transactions/GetTransactionAssetsByType/`;
export const insertUpdateSubscription = `${baseURL}Transactions/InsertUpdateSubscription`;
export const insertUpdateTransaction = `${baseURL}Transactions/InsertUpdateTransaction`;
export const getTransactionByIdAPI = `${baseURL}Transactions/GetTransactionDetails/`;
export const getAssetLotByPortfolio=`${baseURL}Portfolios/GetPortfolioAssetLot/`;
export const insertAssetLots=`${baseURL}Portfolios/InsertPortfolioAssetLot`;
export const deleteTransaction = `${baseURL}Transactions/DeleteTransaction/`;
export const getTransactionCashByAssetLot = `${baseURL}Transactions/GetTransactionCashByAssetLot/`;
export const insertUpdateRedemption=`${baseURL}Transactions/InsertUpdateRedemptionTransaction`;
export const getPortfolioAssetsById =`${baseURL}Portfolios/GetPortfolioExistingAssetsByType/`;
export const getRedemptionTransactionbyId = `${baseURL}Transactions/GetRedemptionTransactionDetails/`;
export const insertUpdateReceiveCash = `${baseURL}Transactions/InsertUpdateReceiveCashTransaction`;
export const CheckIfAllocationExistsAPI=`${baseURL}Transactions/CheckIfAllocationExists/`;
export const transactionSaveCapitalCallAndSubAPI =`${baseURL}Transactions/InsertUpdateSubscriptionTransaction`;

//Reporting
export const getreportingCategory = `${baseURL}Reporting/GetReportCategory/` 
export const getreportingCategoryById = `${baseURL}Reporting/GetReports/`

//Asset Liquidity
export const getAssetLiquidity=`${baseURL}Liquidity/GetLiquidityRedemptionInfo?`;
export const postLiquidityTerms=`${baseURL}Liquidity/InsertOrUpdateLiquidityRedemptionTerms`;
export const getLiquidityFromDateDS=`${baseURL}Liquidity/GetLiquidityRedemptionPayoutFromDateType`;
export const getLiquidityBasicsDS=`${baseURL}Liquidity/GetLiquidityRedemptionPayoutBasis`;
export const postLiquidityPayout=`${baseURL}Liquidity/InsertOrUpdateLiquidityRedemptionPayouts`;
export const deleteLiquidityTermAPI=`${baseURL}Liquidity/DeleteLiquidityRedemptionTerms/`;
export const deleteLiquidityPayoutsAPI=`${baseURL}Liquidity/DeleteLiquidityRedemptionPayouts/`;
export const getFirstRedemptionMonthsAPI=`${baseURL}Liquidity/GetLiquidityRedemptionMonths/`;
export const getLiquiditySummaryData=`${baseURL}LiquidityEngine/GetLiquiditySummaryAtAssetLevel`;
export const getLiquidityCashFlowAssets = `${baseURL}LiquidityEngine/GetLiquidityCashFlowAssets`;
export const getLiquidityCashFlow = `${baseURL}LiquidityEngine/GetLiquidityCashFlow`;
export const deleteLiquidityCashFlow = `${baseURL}LiquidityEngine/DeleteLiquidityCashFlow`;
export const insertOrUpdateCashFlow = `${baseURL}LiquidityEngine/InsertOrUpdateLiquidityCashFlow`;
export const getLiquidityScheduleReport = `${baseURL}LiquidityEngine/GetLiquidityScheduleReport`;
export const getPDFLiquidityReport = `${baseURL}ReportingEx/GetPdfLiquidityReport`;
export const getCashFlowModel = `${baseURL}LiquidityEngine/GetLiquidityCashFLowModel`;
export const getIncExpContactAssets = `${baseURL}LiquidityEngine/GetIncExpContactAssets`;
export const insertIncExpAsset = `${baseURL}LiquidityEngine/InsertIncExpAsset`;
export const deleteIncExpAsset = `${baseURL}LiquidityEngine/DeleteIncExpAsset`;

//Investor Tracker
export const getInvestorTracking = `${baseURL}InvestorTracking/GetInvestorTrackingTransactions`;
export const getTrackingtransactionTypes=`${baseURL}InvestorTracking/GetInvestorTrackingTransactionTypes`;
export const getFamilies=`${baseURL}Common/GetFamilies/false`;
export const getInvestorPortfolio = `${baseURL}InvestorTracking/GetInvestorTrackingPortfolios`;
export const getInvestorAsset = `${baseURL}InvestorTracking/GetInvestorTrackingAssets`;
export const getInvestorStatus = `${baseURL}InvestorTracking/GetInvestorTrackingStatus`;
export const getInvestorActivities = `${baseURL}Activity/GetInvestorActivities/`;
export const insertorupdateInvestorTracking = `${baseURL}InvestorTracking/InvestorTrackingInsertOrUpdate`;
export const getInvestortrackersourcedata = `${baseURL}InvestorTracking/GetInvestorTrackerSourceData`;
export const getshareclassbyType= `${baseURL}InvestorTracking/GetInvestorTrackingShareClassesByType`;
export const getassetclassbyType=`${baseURL}InvestorTracking/GetInvestorTrackingAssetsByType`;
export const deleteInvestorTracking=`${baseURL}InvestorTracking/DeleteInvestorTracking`;
export const gettrackingdetails=`${baseURL}InvestorTracking/GetInvestorTrackingDetails`;
export const getBulkUpdateDetails = `${baseURL}InvestorTracking/GetInvestorTrackingBulkTransDetails`;
export const insertBulkUpdate = `${baseURL}InvestorTracking/InvestorTrackingUpdateForBulkEdit`;
// Investor Accounts'
export const getTaxEntityListAPI=`${baseURL}TaxEntity/GetTaxEntityList?searchTerm=`;
export const getTaxEntityDetailsAPI=`${baseURL}TaxEntity/GetTaxEntityDetails/`;
export const deleteTaxEntityAPI=`${baseURL}TaxEntity/DeleteTaxEntity/`;
export const getTaxStatusDSApi=`${baseURL}TaxEntity/GetTaxEntityTaxStatus`;
export const getTaxEntityStatusDSApi=`${baseURL}TaxEntity/GetTaxEntityStatus`;
export const getNewIssueDSApi=`${baseURL}TaxEntity/GetTaxEntityNewIssue`;
export const updateTaxEntityAPI=`${baseURL}TaxEntity/InsertOrUpdateTaxEntityDetails`;
export const getErisaAPI=`${baseURL}TaxEntity/GetErisa`;
export const getFormPFAPI = `${baseURL}TaxEntity/GetFormPF`;
export const getTaxEntityContacts = `${baseURL}TaxEntity/GetTaxEntityContacts/`;
export const getTaxEntityContactAccess = `${baseURL}TaxEntity/GetTaxEntityContactAccess/`;
export const getTaxEntityPortfoliosApi = `${baseURL}TaxEntity/GetTaxEntityPortfolios/`;
export const deleteTaxEntityContact = `${baseURL}TaxEntity/DeleteTaxEntityContact/`;
export const insertOrUpdatetaxEntityContact = `${baseURL}TaxEntity/InsertOrUpdatetaxEntityContact`;
export const checkTaxEntityRole = `${baseURL}TaxEntity/CheckIfCanAddRole/`;
export const getContactRoles = `${baseURL}Contact/GetContactRoles`;
export const getContactRoleDefaultAccess = `${baseURL}Contact/GetContactRoleDefaultAccess/`;


// Investor Relationship
export const getContactRelatedContacts = `${baseURL}Contact/GetContactRelatedContacts/`;
export const getContactRelationTypes = `${baseURL}Contact/GetContactRelationTypes`;
export const deleteContactRelation = `${baseURL}Contact/DeleteContactRelation/`;
export const insertOrUpdateContactRelation = `${baseURL}Contact/InsertOrUpdateContactRelation`;

// custom usersetting
export const getcomponentname = `${baseURL}Common/GetComponent/`
export const getpagelists = `${baseURL}Common/Getpagelist`
export const DownloadImportReturnsTemplate = `${baseURL}AssetValuation/DownloadImportReturnsTemplate`;
export const DownloadImportMarketIndexTemplate = `${baseURL}AssetValuation/DownloadMarketIndexImportReturnsTemplate`;
export const DownloadAUMImportTemplate = `${baseURL}AssetValuation/DownloadAUMReturnsTemplate`;

// Client Statement adim family 
export const getAllFamilies = `${baseURL}Family/GetFamilies`;
export const getFamilyMapping = `${baseURL}Family/GetFamilyMappings/`;
export const getFamilyEntitiesToAdd = `${baseURL}Family/GetFamilyEntitiesToAdd/`;
export const insertUpdateFamily = `${baseURL}Family/InsertUpdateFamily/`;
export const insertFamilyMapping = `${baseURL}Family/InsertFamilyMapping/`;
export const deleteFamily = `${baseURL}Family/DeleteFamily/`;
export const deleteFamilyMapping = `${baseURL}Family/DeleteFamilyMapping/`;

//  client statement  adim  client statement
export const getClientStatementAPI=`${baseURL}ClientStatement/GetClientStatements`;
export const getCSByIDAPI=`${baseURL}ClientStatement/GetClientStatements?clientStatementId=`;
export const getLinkedPortfolioAPI=`${baseURL}ClientStatement/GetClientStatementMappings/`;
export const insertUpdateCSAPI=`${baseURL}ClientStatement/InsertUpdateClientStatement`;
export const getReviewersAPI=`${baseURL}Common/GetAllUsers?jobTitleid=5`;
export const getbatchAPI=`${baseURL}Common/GetEnumeration/ClientStatementBatchNum`;
export const getFrequnecyAPI=`${baseURL}Common/GetEnumeration/ClientStatementFrequency`;
export const deleteCSAPI=`${baseURL}ClientStatement/DeleteClientStatement/`;
export const deleteCSPortfolioAPI=`${baseURL}ClientStatement/DeleteClientStatementMapping/`;
export const getEntitesCSAPI=`${baseURL}ClientStatement/GetClientStatementNewMappings/`;
export const saveCSLinkedPortfolio=`${baseURL}ClientStatement/InsertClientStatementMapping/`;
export const getCSSettings = `${baseURL}CSLegacy/GetClientStatementSettings/`;
export const getDocumentByteArray = `${baseURL}CSLegacy/GenerateEncodeParam`;
export const downloadCS = `${baseURL}CSLegacy/GenerateClientStatement`;
export const SaveclientSetting = `${baseURL}CSLegacy/InsertClientStatementSettings`;
export const getCSBatch=`${baseURL}Common/GetEnumeration/ClientStatementBatchNum`;
export const getCSFamily=`${baseURL}ClientStatement/GetClientStatementActiveFamilies`;
export const getCSOwner = `${baseURL}Common/GetAllUsers?jobTitleid=5`;
export const getCSFrequency=`${baseURL}Common/GetEnumeration/ClientStatementFrequency`;
export const getCSByBatch=`${baseURL}ClientStatement/GetClientStatementsByBatch`;
export const generateCSBatch=`${baseURL}ClientStatement/UpdateClientStatementStatusForBatch`;
export const getCSStatusType=`${baseURL}ClientStatement/GetClientStatementStatusTypes`;
export const getCSForReview=`${baseURL}ClientStatement/GetClientStatementsForReview`;
export const updateCSComment=`${baseURL}ClientStatement/InsertOrUpdateClientStatementComments`;
export const getCSStatusHistory=`${baseURL}ClientStatement/GetClientStatementStatusHistory/`;
export const getCSAccordion=`${baseURL}ClientStatement/GetClientStatementReviewTabDocuments`;
export const getClientStatementSum = `${baseURL}ClientStatement/GetClientStastementSummary/`;
export const getClientReportSettings = `${baseURL}ClientStatement/GetClientReportSettings`;
export const deleteReportSettings = `${baseURL}ClientStatement/DeleteReportSettings`
export const getAssetWithoutReportSettings = `${baseURL}ClientStatement/GetAssetWithoutReportSettings`
export const insertOrUpdateReportSettings = `${baseURL}ClientStatement/InsertOrUpdateReportSettings`
export const insertOrUpdateReviewStatus = `${baseURL}ClientStatement/UpdateClientStatementStatusForReview`;
export const getClientStatementDefaultViewURL= `${baseURL}ClientStatement/GetClientStatementDefaultView/`;
export const getClientStatementUnMappedAccountContact= `${baseURL}ClientStatement/GetClientStatementUnMappedAccountContact/`;

//client Reportin setting statergy
export const getClassificationItemsReportinsetting = `${baseURL}Common/GetClassificationItems`;

//UserPageTracking
export const updatePageTrackingAPI=`${baseURL}UserPageTracking/InsertUserPageTracking`;
export const getUserPageTracking = `${baseURL}UserPageTracking/GetUserPageTracking`;
export const getUsersLogin = `${baseURL}UserPageTracking/GetUsersLogin`;

//transaction
export const inserUpdateCommitment=`${baseURL}Transactions/InsertUpdateCommitment`;
export const insertUpdateTransactionAPI = `${baseURL}Transactions/InsertUpdateTransaction`;
export const insertUpdateSubscriptionAPI = `${baseURL}Transactions/InsertUpdateSubscriptionTransaction`;
export const getPortfoliosByassetTransType=`${baseURL}Portfolios/GetPortfoliosByAssetAndType/`;
//Portfolio Attribution
export const getTreeofFamilyClientStatements = `${baseURL}Family/GetTreeofFamilyClientStatements`;
export const getPortfoliosByFamily = `${baseURL}Family/GetPortfoliosByFamily`;
export const getPortfolioValuationByAssetLot = `${baseURL}Portfolios/GetPortfolioValuationByAssetLot`;
export const getPortfolioCashAccounts = `${baseURL}Portfolios/GetPortfolioCashAccounts/`;
export const getPortfolioAttributionGridData = `${baseURL}PortfolioAttr/AttributionProcessing`;
export const getPortfolioAttributionLegacyData = `${baseURL}AttributionLegacy/BuildPortAttrData`;
export const getPortfolioAttributionUIData=`${baseURL}AttributionLegacy/BuildPortAttrDataUI`;
export const getPortfolioAttributionViews = `${baseURL}AttributionLegacy/GetAttrCustomViews`;
export const exportTimeSeriesAPI = `${baseURL}AttributionLegacy/ExportTimeSeries`;
export const deleteView = `${baseURL}AttributionLegacy/DeleteAttributionCustomViews`;
export const insertNewAttrAPI = `${baseURL}AttributionLegacy/InsertAttributionCustomViews`;
export const UpdateAttributionCustomViewsAPI = `${baseURL}AttributionLegacy/UpdateAttributionCustomViews`;
export const renameView = `${baseURL}AttributionLegacy/RenameAttributionCustomViews`;
export const getPortfolioByClientStmt=`${baseURL}AttributionLegacy/GetPortfolioByClientStatement/`;
export const modifyPPLI = `${baseURL}AttributionLegacy/ModifyPPLI`;
export const getPPLI = `${baseURL}AttributionLegacy/GetPPLI`;
export const getValuationStatus = `${baseURL}AttributionLegacy/GetValuationStatus?`;
export const getPortfolioCustodiansAccounts = `${baseURL}Portfolios/GetPortfolioCustodiansAccounts?`;

// pipeline
export const getPortfolioByAssetType = `${baseURL}Portfolios/GetPortfoliosByAssetAndType`;
export const getPipeline = `${baseURL}Pipeline/GetPipeline`;
export const getAllCustomViews = `${baseURL}Pipeline/GetAllCustomViews`;
export const getPipelineType = `${baseURL}Pipeline/GetPType`;
export const getPipelineSize = `${baseURL}Pipeline/GetSize`;
export const getPipelineStage = `${baseURL}Pipeline/GetStage`;
export const getCustomViewSettings = `${baseURL}Pipeline/GetCustomViewSettings`;
export const getSelectedCustomView = `${baseURL}Pipeline/GetSelectedCustomView`;
export const getCustomViewColumnAvailable = `${baseURL}Pipeline/GetCustomViewColumnAvailable`;
export const insertPipelineCustomviewSettings = `${baseURL}Pipeline/InsertCustomviewSettings`;
export const deleteCustomView = `${baseURL}Pipeline/DeleteCustomView`;
export const updateCustomViewName = `${baseURL}Pipeline/UpdateCustomViewName`;
export const getPiplelineTransactionType= `${baseURL}Pipeline/GetTransTypePipeline`;
export const insertOrUpdatePipeline= `${baseURL}Pipeline/InsertOrUpdatePipeline`;
export const getPipelineSummarydata= `${baseURL}Pipeline/GetPipelineSummary`;
export const getPipelineCompanyContact= `${baseURL}Pipeline/GetCompanyContact`;
export const deletePipeline = `${baseURL}Pipeline/DeletePipeline/`;
export const getPipelineOwners = `${baseURL}Common/GetAllUsers?jobTitleid=6`;


//Email Controller 
export const getEmailTemplateListAPI=`${baseURL}EmailMarketing/GetEmailTemplates`;
export const getSelectedEmailTemplateAPI=`${baseURL}EmailMarketing/GetEmailTemplates?templateId=`;
export const getEmailIdListAPI=`${baseURL}EmailMarketing/GetEmailIdList`;
export const getTrackingRecipientsAPI=`${baseURL}EmailMarketing/GetTrackingRecipients`;
export const getTrackingListDetailsAPI=`${baseURL}EmailMarketing/GetTrackingListDetails`;
export const getTrackingHourlyReportAPI=`${baseURL}EmailMarketing/GetHourlyPerformanceToday`;
export const deleteEmailTemplate=`${baseURL}EmailMarketing/DeleteEmailTemplate/`;
export const updateEmailTemplateAPI = `${baseURL}EmailMarketing/UpdateEmailTemplate`;
export const emailMarketingTestSentAPI = `${baseURL}EmailMarketing/TestSend`;
export const getEmailDocuByTemplateIdAPI=`${baseURL}EmailMarketing/GetEmailAttachmentContentInfo?attachmentId=`;
export const getRecipientsDataByContactId = `${baseURL}EmailMarketing/GetEmailTemplateContactInfo`;
export const emailMarketingSendAPI = `${baseURL}EmailMarketing/SendMarketingMail`;
export const getTrackingDetailsAPI = `${baseURL}EmailMarketing/GetTrackingDetails`;
export const getTrackingListsAPI=`${baseURL}EmailMarketing/GetTrackingListDetails`





//PortalAccess
export const getGrantedPortalAccessAPI=`${baseURL}PortalAccess/GetGrantedPortalAccess/`;
export const getWebMenuPermissionsAPI = `${baseURL}PortalAccess/GetWebMenuPermissions/`;
export const getDelegatePortalAccessAPI = `${baseURL}PortalAccess/GetDelegatedPortalAccess/`;
export const updatetaxEntityAccess=`${baseURL}PortalAccess/UpdateTaxEntityAccess`;
export const updateInvestorWebAcces = `${baseURL}PortalAccess/UpdateInvestorWebAccess`;

export const getAvaialbleTaxEntitie = `${baseURL}PortalAccess/GetAvaialbleTaxEntities`;
export const getAvailableInvestors = `${baseURL}PortalAccess/GetAvailableInvestors`;
export const getWebRoles = `${baseURL}PortalAccess/GetWebRoles`;
export const getWebRoleDefaultAccess = `${baseURL}PortalAccess/GetWebRoleDefaultAccess/`;
export const deletetaxentityAcces=`${baseURL}PortalAccess/DeleteTaxEntityAccess/`;
export const insertTaxEntityWebAccess = `${baseURL}PortalAccess/InsertTaxEntityWebAccess`;
export const insertInvestorWebAccess = `${baseURL}PortalAccess/InsertInvestorWebAccess`;
export const insertupdatemenuAcces = `${baseURL}PortalAccess/InsertOrUpdateMenuPermissions`;
export const copyContactWebAccess = `${baseURL}PortalAccess/CopyContactWebAccess`;

//application Settings 
export const applicationsListAPI = `${baseURL}Common/GetEnumeration/Applications `;
export const getAppSettings = `${baseURL}Common/GetAppSetting`;
export const updateAppConfigValues = `${baseURL}Common/UpdateAppConfigValues`;
export const getClassificationParents = `${baseURL}ApplicationSettings/GetClassificationParents/`;
export const getServerDetails = `${baseURL}ServerInfo/GetServerDetails`;

// billing 
export const getBillableAssetsGetExistingAPI = `${baseURL}Billing/BillableAssetsGetExisting`;
export const getBillableAssetToFlagAPI=`${baseURL}Billing/BillableAssetsGetRecordsToFlag`;
export const insertNewBillableAsset = `${baseURL}Billing/SaveNewBillableAsset`;
export const getBillingGetExistingClientsAPI =`${baseURL}Billing/BillingGetExistingClients`;
export const updateBillableAsset = `${baseURL}Billing/UpdateBillableAssetFlag`;
export const deleteBillableAsset = `${baseURL}Billing/DeleteBillableAsset`;
export const insertOrUpdateBillingAPI=`${baseURL}Billing/SaveBillingdetails`;
export const getBillingContactsAPI=`${baseURL}Billing/GetBillingContacts`;
export const getBillingFeeTypesAPI=`${baseURL}Billing/GetBillingFeeTypes`;
export const getBillingFeeDefintionAPI=`${baseURL}Billing/GetBillingFeeDefinition/`;
export const getAllActivePortFolioIds =`${baseURL}Billing/GetAllActivePortfolioList`;
export const getAssetsbyPortfolioId = `${baseURL}Billing/GetAssetsbyPortfolioId`;
export const getClientBillingMapping = `${baseURL}Billing/GetClientBillingMapping`;
export const getClientBillingFee=`${baseURL}Billing/GetClientFee/`;
export const insertInvoice=`${baseURL}Billing/InsertBillingInvoice/`;
export const insertInvoiceMapping=`${baseURL}Billing/InsertBillingInvoiceMapping/`;
export const getBillingInvoice = `${baseURL}Billing/GetBillingInvoice`;
export const getBillingInvoiceMapping=`${baseURL}Billing/GetBillingInvoiceMapping/`;
export const deleteInvoiceMapping=`${baseURL}Billing/DeleteBillingInvoiceMapping/`;
export const getClientMgmtFee=`${baseURL}Billing/GetManagementFees`;
export const insertorupdateFee=`${baseURL}Billing/SaveInternalFees`;
export const billingInsertClntBillMappingAPI=`${baseURL}Billing/BillingInsertClntBillMapping`;
export const billingGetAllInvoiceAPI=`${baseURL}Billing/GetAllInvoices`;
export const getBillingReview = `${baseURL}Billing/GetBillingReview`;
export const saveinvoicepdfdoc = `${baseURL}ReportingEx/SaveInvoiceDocument`;
export const getBillingGetExistingInvoiceAPI=`${baseURL}Billing/GetAllInvoices`;
export const invoiceUpdateOrInsertAPI=`${baseURL}Billing/InvoiceUpdateOrInsert`;
export const getBillingCustomTemplateAPI=`${baseURL}Billing/GetBillingCustomEmailTemplates`;
export const saveBillingpdfdoc = `${baseURL}ReportingEx/SaveBillingDocument`;
export const updateBillingdocstatus = `${baseURL}Billing/UpdateDocumentStatus/`;
export const updateInvoiceDocument = `${baseURL}Billing/UpdateInvoiceDocument/`;
export const getInvoiceMappingAPI=`${baseURL}Billing/GetInvoiceMapping`;
export const getInvoiceNewMappingAPI=`${baseURL}Billing/GetInvoiceNewMapping`;
export const getBillingInvoiceNewMappingAPI=`${baseURL}Billing/GetNewBillingInvoiceMapping`;
export const insertInvoiceMappingAPI =`${baseURL}Billing/InsertInvoiceMapping`;
export const deleteInvoiceMappingAPI=`${baseURL}Billing/DeleteInvoiceMapping?invoiceMappingId=`;
export const insertBillingCustomEmailTemplateAPI=`${baseURL}Billing/InsertBillingCustomEmailTemplate`;
export const getIsBillableAPI =`${baseURL}Billing/GetIsBillable`;
export const getBillingDocs = `${baseURL}Billing/GetGenerateBillingDetails`;
export const insertClientBillingApproval =`${baseURL}Billing/InsertClientBillingApproval`;
export const deleteBillingApproval=`${baseURL}Billing/DeleteBillingApproval/`;
export const updatebillingApproval =`${baseURL}Billing/ApproveBilling/`;
export const getinvoiceData =`${baseURL}Billing/GetInvoiceData/`;
export const getbillingInvoiceadjustment=`${baseURL}Billing/GetInvoiceAdjustmentText`;
export const insertInvoiceApproval=`${baseURL}Billing/InsertInvoiceApproval`;
export const updateInvoiceApproval=`${baseURL}Billing/UpdateInvoiceApproval`;
export const getpdfbillingReport=`${baseURL}ReportingEx/GetPdfBillingReport`;
export const getpdfinvoiceReport=`${baseURL}ReportingEx/GetPdfInvoiceReport`;
//PortalAccess sync
export const SyncTablesToWebAPI =`${baseURL}PortalAccess/SyncTablesToWeb`;

//Report viewer http://uatreporting.aes.corp/
// export const getReportController=`${baseURL}ReportViewer/GetReportParam?sReportName=`;
export const getReportController = `${baseURL}Reporting/GetReportParam?sReportName=`;
export const getReportContent = `${baseURL}Reporting/GetReportViewBinary`;
export const getReportPDFContent = `${baseURL}Reporting/GetReportView`;
export const getDyanmicReportDataSource = `${baseURL}Reporting/GetReportParamValue`

//InvFeeds
export const insertNewAssetLot = `${baseURL}InvFeeds/InsertAssetLot`;
export const getNewPortfolios = `${baseURL}InvFeeds/GetNewPortfolios`;
export const showAllPortfolios = `${baseURL}InvFeeds/GetAssetPortfolios`;
export const getNewAssets = `${baseURL}InvFeeds/GetNewAssets`;
export const getPortfolioAssets = `${baseURL}InvFeeds/GetPortfolioAssets`;
export const insertAsset = `${baseURL}InvFeeds/InsertAsset`;
export const loadValuations = `${baseURL}InvFeeds/LoadValuations`;
export const getNewAssetLots = `${baseURL}InvFeeds/GetNewAssetLots`;
export const updateSecurities = `${baseURL}InvFeeds/UpdateSecurityAssetXref`;
export const checkForDefaultShareClass = `${baseURL}Assets/AssetHasDefaultShareClass/assetId`;
export const getPortfolioMappings = `${baseURL}InvFeeds/GetPortfolioMappings`;
export const portfolioSummarize = `${baseURL}InvFeeds/SummarizeValuations`;
export const updateSecurityIgnoreFlag=`${baseURL}InvFeeds/UpdateSecurityIgnoreFlag`;
//clientWebsites
export const getcommonPortfolios = `${baseURL}Common/GetPortfolios/`;
export const getcommonAssets= `${baseURL}Common/GetAssetsDDL/`;
export const getClientWebSites=`${baseURL}ClientWebsite/GetWebsiteLoginDetails`;
export const insertorupdatewebsite = `${baseURL}ClientWebsite/InsertOrUpdateWebsiteLogin`;
export const deletewebsite = `${baseURL}ClientWebsite/DeleteWebsiteLogin`;



//partnership
export const getPartnership=`${baseURL}Partnership/GetPartnerships`;
export const getPartnershipPartner=`${baseURL}Partnership/GetPartnershipsPartners`;
export const getPartnershipPortfolio=`${baseURL}Partnership/GetPortfolioToAdd`;
export const insertPartnership=`${baseURL}Partnership/InsertNewPartnership`;
export const insertPartner=`${baseURL}Partnership/InsertNewPartner`;
export const getPartnerShipDetails=`${baseURL}Partnership/GetPartnershipDetails`;
export const insertNewPartnershipDetail=`${baseURL}Partnership/InsertNewPartnershipDetail`;
export const updatePartnershipDetail=`${baseURL}Partnership/UpdatePartnershipDetail`;

//Expense
export const getExpenseCategoryTypes = `${baseURL}LiquidityEngine/GetIncExpCategoryTypes`;
export const getexpenseCategory=`${baseURL}LiquidityEngine/GetIncExpCategories`;
export const getexpenseSubCategories=`${baseURL}LiquidityEngine/GetIncExpSubCategories/`;
export const getExpensebyContact = `${baseURL}LiquidityEngine/GetContactIncExp/`;
export const insertorupdateContactExpense=`${baseURL}LiquidityEngine/InsertOrUpdateContactIncExp`;
export const insertExpenseSubCategory = `${baseURL}LiquidityEngine/InsertOrUpdateIncExpSubCategory`;
// export const insertorupdateContactExpense = `${baseURL}LiquidityEngine/InsertOrUpdateContactExpenses`;



//Asset Duedilligence
export const getDDQCategories = `${baseURL}DDQ/GetCategories`;
export const getDDQsubCategories = `${baseURL}DDQ/GetSubCategories`;
export const getDDQQuestionsAndAnswer = `${baseURL}DDQ/GetQuestionsAndAnswers/`;
export const getDDQQuestions = `${baseURL}DDQ/GetQuestions`;
export const getDDQInsertOrUpdateAnswer = `${baseURL}DDQ/InsertOrUpdateAnswer`;
export const getDDQGetAllAnswers = `${baseURL}DDQ/GetAnswers`;
export const getApprovalListAPI = `${baseURL}DDQ/GetApprovalByAssetId?AssetId=`;
export const getApprovalStatusAPI= `${baseURL}DDQ/GetApprovalStatus?ddqApprovalId=`;
export const InsertUpdateApprovalAPI=`${baseURL}DDQ/InsertUpdateApproval`;



//Admin DDQ
export const insertOrUpdateDDQCategory = `${baseURL}DDQ/InsertOrUpdateCategory`;
export const insertOrUpdateDDQSubCategory = `${baseURL}DDQ/InsertOrUpdateSubCategory`;
export const insertOrUpdateDDQQuestion = `${baseURL}DDQ/InsertOrUpdateQuestion`;
export const deleteDDQCategory = `${baseURL}DDQ/deleteCategory`;
export const deleteDDQSubCategory = `${baseURL}DDQ/deleteSubCategory`;
export const deleteDDQQuestion = `${baseURL}DDQ/deleteQuestion`;
export const getDDQNoteTypesAndSubTypes = `${baseURL}DDQ/GetNoteTypesAndSubTypes`;
export const getAnswerTypes = `${baseURL}DDQ/GetAnswerTypes`;





//Billing InsertUpdateFeeDefinition
export const insertOrUpdateFeeDefinition = `${baseURL}Billing/InsertOrUpdateFeeDefinition`;
//Client Report setting 
export const getReportClassificationsAPI = `${baseURL}ClientStatement/GetReportClassifications`;


// chat bot
export const chatQuery1 = `${chatBotURL}GetPerfSummary`;





//GenAI-NextGen GenAI/InsertOrUpdateFavouritePrompts
export const getFavouritePrompts=`${baseURL}GenAI/GetFavoritePrompts`;
export const insertOrUpdateFavouritePrompts=`${baseURL}GenAI/InsertOrUpdateFavoritePrompts`;
export const resetFavoritePrompts=`${baseURL}GenAI/ResetFavoritePrompts`;
export const insertPrompt = `${baseURL}GenAI/InsertPromptLog`;
export const getPrompts = `${baseURL}GenAI/GetPromptLogs`;
export const removeFavoritePrompt=`${baseURL}GenAI/RemoveFavoritePrompts/`;
export const updateFavPromptSortOrder = `${baseURL}GenAI/UpdateFavoritePromptSortOrder`;
export const genaiChat = `${baseURL}GenAI/GetGenAPI`;
export const genaiChatPromptStatusCheck = `${baseURL}GenAI/GetAIPromptStatus/`;
export const checkHealth = `${baseURL}GenAI/IsServicesLoaded`;
export const toggleCache = `${chatBotURL}/cache/toggle`;
export const ingestCacheFile = `${baseURL}GenAI/ingest_cache_file`;
export const flushCache = `${baseURL}GenAI/FlushCache`;
export const genAIHealth = `${baseURL}GenAI/IsServicesLoaded`;
export const genAIUploadFile = `${baseURL}GenAI/upload_train_file`;
export const getSystemPrompts = `${baseURL}GenAI/GetSystemPrompts`;
export const upsertSystemPrompts = `${baseURL}GenAI/UpsertSystemPrompts`;
export const deleteSystemPrompt = `${baseURL}GenAI/DeleteSystemPrompt`;
export const getLatestTrainingFile = `${baseURL}GenAI/GetLatestTrainingFile`;
export const insertTrainingFile = `${baseURL}GenAI/UploadTrainingFile`;
export const getTrainingFileList = `${baseURL}GenAI/GetTrainingFilesList`;
export const getTrainingFileById = `${baseURL}GenAI/GetTrainingFileById`;


//Custodians
export const getCustodianSources = `${baseURL}Custodian/GetCustodianSources`;
export const getCustodians = `${baseURL}Custodian/GetCustodians`;
export const getCustodianAccounts = `${baseURL}Custodian/GetCustodianAccounts`;
export const getCustodianAssets = `${baseURL}Custodian/GetPortfolioAssets`;
export const upsertCustodian = `${baseURL}Custodian/InsertOrUpdateCustodian`;
export const upsertCustodianAccount = `${baseURL}Custodian/InsertOrUpdateCustodianAccount`;
export const deleteCustodian = `${baseURL}Custodian/DeleteCustodian`;
export const deleteCustodianAccount = `${baseURL}Custodian/DeleteCustodianAccount`;
export const InsertAllocationSettings = `${baseURL}Common/InsertSettings`;
export const getAllocationSettings = `${baseURL}Common/GetSettings`;

export const getEntityExceptions = `${baseURL}Exception/GetEntityExceptions`;
export const getExceptionCategory = `${baseURL}Exception/GetExceptionCategories`;
export const getExceptionAssets= `${baseURL}Exception/GetExceptionAssets`;
export const getmonitoringTolerance = `${baseURL}Exception/GetExceptionEntTolerances`;
export const getexceptionTypes= `${baseURL}Exception/GetExceptionTypes`;
export const getexceptionnotify = `${baseURL}Exception/GetExceptionNotifTypes`;
export const getExceptionStatus = `${baseURL}Common/GetEnumeration/ExceptionStatus`;

export const getExceptionValueTypes = `${baseURL}Exception/GetExceptionValueTypes`;
export const getExceptionNotifCategories = `${baseURL}Exception/GetExceptionNotifCategories`;
export const insertOrUpdateExceptionType = `${baseURL}Exception/InsertOrUpdateExceptionType`;
export const getExceptionTypeDetails = `${baseURL}Exception/GetExceptionTypeDetails`;
export const deleteExceptionType = `${baseURL}Exception/DeleteExceptionType`;
export const getExceptionEntTolerances = `${baseURL}Exception/GetExceptionEntTolerances`;
export const insertOrUpdateTolerance = `${baseURL}Exception/InsertOrUpdateTolerance`;
export const deleteTolerance = `${baseURL}Exception/DeleteTolerance`;
export const insertOrUpdateNotifType = `${baseURL}Exception/InsertOrUpdateNotifType`;
export const getEntityExceptionDetails = `${baseURL}Exception/GetEntityExceptionDetails`;
export const updateEntityException = `${baseURL}Exception/UpdateEntityException`;


export const getAssetAllocationReport=`${baseURL}ReportingEx/GetAssetAllocationReport`;


export const getThirdPartyDataAPI=`${baseURL}ThirdPartyData/GetThirdPartyDataList`;



export const sendAdminNotifcation = `${baseURL}sendNotification`;
export const notificationHubService = `${baseURL}notificationHubService`;
export const getActiveusers = `${baseURL}activeusers`;
// export const notificationHubService = `${baseURL}notificationHubService`;//////

// export const notificationHubService = `${baseURL}notificationHubService`;
export const sendNotificationToUser = `${baseURL}sendToConnectionID`;
export const getUnreadNotifications = `${baseURL}getUnreadNotifications`;
export const markAsReadNotification =  `${baseURL}markAsRead`;
export const checkNotificationAccess = `${baseURL}checkNotificationAccess`;